module.exports = __webpack_public_path__ + "static/media/cloud-upload.4790df3e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/cloud-upload.svg
// module id = 2328
// module chunks = 1